import { ConcreteEncodable } from "./ConcreteEncodable";

import { DIRequestItemImplEncoder } from "../../encoder/DIRequestItemImplEncoder";

import * as CubiqTS from "../../index";
import { DIRequestItem } from "../DIRequestItem";

export class DIRequestItemImpl extends ConcreteEncodable implements DIRequestItem {
  public static enType: string = "com.bcdfx.model.DIRequestItemImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public markup: CubiqTS.BigNumber | null = null;
  /*FID=3*/
  public markupType: CubiqTS.MarkUpType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = DIRequestItemImplEncoder.Instance;
    this.setEncodableType(DIRequestItemImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "DIRequestItemImpl[" +
      "orderId=" +
      this.orderId +
      "markup=" +
      this.markup +
      "markupType=" +
      this.markupType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
